import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getPreviewDetails = (iframeId: number) => {
  return axiosPrivate.get(`/dashboard/api/v1/iframes/${iframeId}`);
};